import { Edit } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { DishComponent } from '../apiTypes';
import { t } from '../constants/translations';
import { useLocale } from '../contexts/locale.context';
import DishComponentPreview from './DishComponentPreview';
import PrimaryButton from './PrimaryButton';

type Props = {
  components: DishComponent[];
  onEdit: () => void;
  label?: string;
};

const DishComponentList = ({ components, onEdit, label }: Props) => {
  const { lang } = useLocale();

  return (
    <>
      {label && components.length > 0 && (
        <Typography variant="body2" color={(t) => t.palette.text.secondary}>
          {label}:
        </Typography>
      )}

      {components.length > 0 && (
        <Box sx={{ my: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {components.map((c) => (
              <DishComponentPreview key={c.id} component={c} />
            ))}
          </Box>

          <IconButton onClick={onEdit}>
            <Edit />
          </IconButton>
        </Box>
      )}

      {components.length === 0 && (
        <PrimaryButton size="small" color="secondary" onClick={onEdit}>
          {t.add_costs_of_production[lang]}
        </PrimaryButton>
      )}
    </>
  );
};

export default DishComponentList;
